export default "__VITE_ASSET__B3AJ47mK__"